var map = {
	"./bus.png": "5603",
	"./drink.png": "e5c0",
	"./other.png": "8af6",
	"./shield.png": "8c60",
	"./ship.png": "16f2",
	"./tour.png": "02d8",
	"./tours.png": "45d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "750a";